export const SOCIALS = {
  instagram: {
    handle: "@theegodbarber33",
    url: "https://instagram.com/theegodbarber33",
  },
  tiktok: {
    handle: "@godbarber33",
    url: "https://www.tiktok.com/@godbarber33",
  },
  facebook: {
    handle: "Reek The God",
    url: "https://www.facebook.com/search/top?q=Reek%20The%20God",
  },
};
